module.exports = __webpack_public_path__ + "img/grid_layout_2_1.ce7d4777.svg";